import { cn } from '@/shared/lib/utils';
import { Separator } from '../../../separator/Separator';
import type { SelectOption } from '../helpers/types';
import { normalizeOptionValue } from '../helpers/utils';

type SearchableSingleSelectContentProps = {
  filteredOptions: SelectOption[];
  activeIndex: number;
  selectValue: string;
  onOptionClick: (option: SelectOption) => void;
  id?: string;
  listboxId?: string;
  fixedBottomOptions?: SelectOption[];
};

export const SearchableSingleSelectContent = ({
  filteredOptions,
  activeIndex,
  selectValue,
  onOptionClick,
  id,
  listboxId,
  fixedBottomOptions,
}: SearchableSingleSelectContentProps) => {
  return (
    <>
      <div role="listbox" id={listboxId} className="max-h-64 overflow-y-auto p-1">
        {filteredOptions.length > 0 ? (
          filteredOptions.map((option, index) => {
            const normalizedValue = normalizeOptionValue(option.value);
            const isCurrentValue = normalizedValue === selectValue;
            return (
              <div
                key={normalizedValue}
                role="option"
                id={id ? `${id}-option-${index}` : undefined}
                aria-selected={isCurrentValue}
                tabIndex={-1}
                className={cn(
                  'cursor-pointer rounded-sm px-2 py-1.5 text-sm outline-none',
                  'hover:bg-neutral-100',
                  index === activeIndex && 'bg-surface-accent',
                  isCurrentValue && 'bg-brand-100 font-bold',
                )}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onOptionClick(option)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    onOptionClick(option);
                  }
                }}
              >
                {option.label}
              </div>
            );
          })
        ) : (
          <div className="py-6 text-center text-sm text-text-muted">検索結果がありません</div>
        )}
      </div>
      {fixedBottomOptions && fixedBottomOptions.length > 0 && (
        <>
          <Separator />
          <div className="p-1">
            {fixedBottomOptions.map((option) => {
              const normalizedValue = normalizeOptionValue(option.value);
              const isCurrentValue = normalizedValue === selectValue;
              return (
                <div
                  key={normalizedValue}
                  role="option"
                  aria-selected={isCurrentValue}
                  tabIndex={-1}
                  className={cn(
                    'cursor-pointer rounded-sm px-2 py-1.5 text-sm outline-none',
                    'hover:bg-neutral-100',
                    isCurrentValue && 'bg-brand-100 font-bold',
                  )}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => onOptionClick(option)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      onOptionClick(option);
                    }
                  }}
                >
                  {option.label}
                </div>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};
